import Vue from 'vue'
import VueRouter from 'vue-router'
import AddPessoa from './components/Pessoas/AddPessoa'
import ListPessoas from './components/Pessoas/ListPessoas'
import PessoaEquipamento from './components/Pessoas/PessoaEquipamento'
import AddEquipamento from './components/Equipamentos/AddEquipamento'
import ListEquipamento from './components/Equipamentos/ListEquipamento'
import Home from './components/Home'
import Login from './components/users/Login'
import CadUser from './components/users/CadUser'


Vue.use(VueRouter)

export const router = new VueRouter({
  routes: [
  {
    path: '*',
    redirect: '/login' 
  },
  {
    path: '/',
    redirect: '/login' 
  },
  {
    name: 'Login',
    path: '/login',
    component: Login
  },
  {
    name: 'Home',
    path: '/home',
    component: Home,
    meta: {
      requiresAuth: true
    },
  },
  {
    name: 'CadUser',
    path: '/caduser',
    component: CadUser,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'AddPessoa',
    path: '/new-pessoa',
    component: AddPessoa,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'ListPessoas',
    path: '/pessoas',
    component: ListPessoas,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'PessoaEquipamento',
    path: '/pessoa-equipamento/:idpessoa',
    component: PessoaEquipamento,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'AddEquipamento',
    path: '/new-equipamento',
    component: AddEquipamento,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'ListEquipamento',
    path: '/equipamentos',
    component: ListEquipamento,
    meta: {
      requiresAuth: true
    }
  }
  
], mode: 'history'});
